<template>
  <ModalDialog
    ref="dialog"
    :title="title"
    :submitting="submitting"
    :submitTitle="submitTitle"
    icon="fa-money-edit-check-alt"
    @closed="onClosed"
    @submitted="onSubmitted">

    <FormGroup v-bind:form="dialogForm" :labelColumnSize="3">
      <FormRow label="Name"><FormInputText placeholder="Name" v-model="salesRate.name" field="name" /></FormRow>
      <FormRow label="Code"><FormInputText placeholder="Code" v-model="salesRate.code" field="code" /></FormRow>
      <FormRow label="Percentage"><FormInputText placeholder="Percentage" v-model="salesRate.percentAdjust" field="percentAdjust" addon="%" /></FormRow>
    </FormGroup>
  </ModalDialog>
</template>

<script>
import _ from 'lodash'
import form from '@/mixins/form'
import ModalDialog from '@/components/modalDialog.vue'
import ModalDialogMixin from '@/mixins/modalDialog'

export default {
  name: "SalesRateDialog",
  mixins: [
    ModalDialogMixin,
    form
  ],
  components: {
    ModalDialog
  },
  props: {
    isCreateMode: Boolean
  },
  data() {
    return {
      id: null,
      salesRate: {},
      dialogForm: {},
      submitting: false
    }
  },
  mounted() {
  },
  computed: {
    title() {
      return this.isCreateMode ? 'New Sales Rate' : 'Edit Sales Rate'
    },
    submitTitle() {
      return this.isCreateMode ? 'Create' : 'Update'
    }
  },
  methods: {
    show(salesRate) {
      // Reset form
      this.salesRate = { }
      this.id = 0
      this.dialogForm = {}
      this.submitting = false

      if(salesRate != null) {
        this.salesRate = _.cloneDeep(salesRate)
        this.id = salesRate.id
      }

      return ModalDialogMixin.methods.show.call(this, arguments)
    },
    onClosed() {
      this.modalClosed(false)
    },
    onSubmitted() {
      this.submitting = true

      var updateData = _.cloneDeep(this.$data.salesRate)

      if(this.isCreateMode) {
        this.$apiService.pricingService.createSalesRate(updateData)
        .then(() => {
          this.submitting = false
          this.modalClosed(true)
          this.hide()
        })
        .catch(err => {
          this.submitting = false
          this.$data.dialogForm = this.processFormResponse(err)
        })
      } else {
        this.$apiService.pricingService.updateSalesRate(this.id, updateData)
        .then(() => {
          this.submitting = false
          this.modalClosed(true)
          this.hide()
        })
        .catch(err => {
          this.submitting = false
          this.$data.dialogForm = this.processFormResponse(err)
        })
      }
    }
  }
}
</script>